import { InjectionToken, makeEnvironmentProviders, EnvironmentProviders } from '@angular/core';

export interface ChangelogEditorConfig {
  apiUri: string;
}

export const CHANGELOG_EDITOR_API_URI = new InjectionToken<string>('CHANGELOG_EDITOR_API_URI');

export function provideChangelogEditor(config: ChangelogEditorConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: CHANGELOG_EDITOR_API_URI, useValue: config.apiUri }
  ]);
}
